import { Component, OnInit } from '@angular/core';
import { ResumeService } from '../../../services/resume.service';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'last-cases-running',
  templateUrl: './last-cases-running.component.html',
  styleUrls: ['./last-cases-running.component.scss'],
})
export class LastCasesRunningComponent implements OnInit {
  dataSource;
  constructor(
    public resumeService: ResumeService,
    public router: Router,
    public userService: UserService
  ) {
    resumeService.lastCasesRunning.subscribe((data) => {
      this.dataSource = data;
    });

    let FRD = this.userService.currentUser.role.units.find(
      (element) => element.code == 'ALT'
    );
    if (FRD && this.userService.currentUser.role.units.length == 1) {
      this.isFRD = true;
    }
  }
  isFRD;
  get isEmpty() {
    return this.dataSource?.length == 0 ? true : false;
  }

  displayedColumns: string[] = [
    'createdAt',
    'updated',
    'gai',
    'description',
    'caseType',
    'assigned',
  ];
  goRoute(iCase) {
    console.log(iCase.status);

    if (
      iCase.status != 'archived' ||
      this.userService.currentUser.role.seeArchivedCases
    )
      this.router.navigate([
        this.isFRD ? `/casesnew/${iCase._id}` : `/case/${iCase._id}/`,
      ]);
  }
  ngOnInit() {}
}
